import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import provinceFetcherHoc from "@hocs/provinceFetcherHoc";
import {Province} from "@models/province";
import {FormattedMessage} from 'react-intl';

const Option = Select.Option;

type ProvinceSelectionProps = {
    mode: SelectionMode,
    onChange: (province: Province) => void
    data: Province[],
    onScroll: (e: SyntheticEvent) => void,
    handleSearch: (query: string) => void,
    onFocus: () => void,
    selectedProvince: Province | null
}


/**
 * This class handle single selection of categories
 * Use Select fro ant-design because it has on scroll option
 * On Change callback return selected province
 * To show parent province in edit mode it would be in the data witch has not fetched yet. Using immutable help to add the selected province in data
 * @param props
 * @constructor
 */
const ProvinceSingleSelection: React.FC<ProvinceSelectionProps> = props => {
    const {handleSearch, onScroll, data = [], onChange, onFocus, selectedProvince} = props;
    const [value, setValue] = useState("");
    //the selected items should be in the data of select to show correctly
    const list = selectedProvince && !data.find(opt => opt.id == selectedProvince.id) ? [...data, selectedProvince] : data;

    useEffect(() => {
        if (selectedProvince) {
            setValue(selectedProvince.id)
        }
    }, [props.selectedProvince]);

    const handleChange = province_id => {
        setValue(province_id);
        const province = data.find(c => c.id == province_id);
        if (province) {
            onChange(province);
        }
    };

    return (
        <Select
            showSearch
            mode={SelectionMode.DEFAULT}
            value={value}
            defaultActiveFirstOption={false}
            showArrow={true}
            filterOption={false}
            onFocus={onFocus}
            onChange={handleChange}
            onSearch={handleSearch}
            onPopupScroll={onScroll}
            placeholder={<FormattedMessage id="app.select_province" defaultMessage={`Select Province`}/>}
            notFoundContent={null}
        >
            {list.map((d, index) =>
                <Option value={d.id} key={index} province={d}>{d.name}</Option>
            )}
        </Select>
    );
};

export default provinceFetcherHoc(ProvinceSingleSelection);


